module.exports = __webpack_public_path__ + "img/kanan.0408149f.jpg";